import { useEffect, useState } from "react";
import axios from "axios";
import { Star } from "lucide-react";
import AddReviewDialog from "./AddReviewDialog";
import { Button } from "@/components/ui/button";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ReviewsBanner() {
  const [summary, setSummary] = useState({ count: 0, average: 0 });

  const load = async () => {
    try {
      const { data } = await axios.get(`${API}/reviews/summary`, { params: { _: Date.now() } });
      setSummary(data);
    } catch {}
  };

  useEffect(() => {
    load();
    const onChange = () => load();
    const onFocus = () => load();
    window.addEventListener("hp:reviews-changed", onChange);
    window.addEventListener("focus", onFocus);
    return () => {
      window.removeEventListener("hp:reviews-changed", onChange);
      window.removeEventListener("focus", onFocus);
    };
  }, []);

  const filled = Math.round(summary.average);

  return (
    <div data-testid="reviews-banner" className="bg-[#0C2E2B] border-y-2 border-[#FFDF00]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-3 flex items-center justify-between flex-wrap gap-3">
        <div className="flex items-center gap-3">
          <div className="flex" data-testid="reviews-banner-stars">
            {[1, 2, 3, 4, 5].map((i) => (
              <Star key={i} className={`w-5 h-5 ${i <= filled ? "fill-[#FFDF00] text-[#FFDF00]" : "text-white/30"}`} />
            ))}
          </div>
          <div className="text-white">
            <span className="font-display font-black text-lg" data-testid="reviews-banner-average">
              {summary.average > 0 ? summary.average.toFixed(1) : "New"}
            </span>
            <span className="text-white/70 text-xs ml-2" data-testid="reviews-banner-count">
              from {summary.count} {summary.count === 1 ? "review" : "reviews"}
            </span>
          </div>
        </div>
        <div className="flex items-center gap-2">
          <a
            href="/reviews"
            data-testid="reviews-banner-see-all"
            className="text-xs font-bold text-white/70 hover:text-white"
          >
            See all →
          </a>
          <AddReviewDialog
            trigger={
              <Button data-testid="reviews-banner-add-btn" className="btn-kinetic rounded-md text-[10px] py-1.5 h-auto">
                Leave a Review
              </Button>
            }
            onSubmitted={load}
          />
        </div>
      </div>
    </div>
  );
}
